import ApiClient from '../ApiClient';
import { API_CONFIG } from '../config';

const publicApiClient = new ApiClient({
  baseUrl: API_CONFIG.publicBaseUrl,
  refreshPath: null,
});

export default publicApiClient;
